<template>
  <ev-inventory-target-panel />
</template>

<script>
import EvInventoryTargetPanel from "../components/config/EvInventoryTargetPanel";

export default {
  components: { EvInventoryTargetPanel }
};
</script>
